import { getAppNavMenu } from './app-menu'
import { Typography } from '@mui/material'
import { SFAppNav } from '../../lib/southfork/components'
import { useAuth } from '../auth/auth-hooks'

export default function AppHeader() {
  const { userType, isLoading } = useAuth()
  // Get appropriate navigation menu based on user type
  const appNavMenu = getAppNavMenu(userType)

  return (
    <div id="app-header">
      <div className="header-left">
        <Typography variant="h1" id="app-title">
          GIC Marketplace
        </Typography>
      </div>
      <div className="header-center">
        {!isLoading && <SFAppNav menu={appNavMenu} />}
      </div>
      <div className="app-header-right">
        <div id="cwicChatContainer"></div>
      </div>
    </div>
  )
}
